<div [dfs]="'p-a:4'"
     *ngIf="!status || status?.busy"
     [ngSwitch]="variant">
    <ng-container *ngSwitchCase="'default'">
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'media'">
        <ng-container *ngTemplateOutlet="mediaTemplate"></ng-container>
    </ng-container>
</div>
<p *ngIf="status?.error"
   [dfs]="'t:p2 c:2 m-v:12px'">{{status!.error}}</p>


<!-- TEMPLATES -->

<ng-template #defaultTemplate>
    <ng-container *ngFor="let _ of lines; let first = first">
        <div [dfs]="['br:50', !first && 'm-t:2']"
             class="_line _waveBackgroundEffect">
        </div>
    </ng-container>
</ng-template>

<ng-template #mediaTemplate>
    <div [dfs]="'d:grid'"
         [style.columnGap.px]="8"
         [style.rowGap.px]="8"
         [style.gridTemplateColumns]="'repeat('+numberOfColumns+', minmax(0, 1fr))'">
        <ng-container *ngFor="let _ of squares">
            <div>
                <div class="_square _waveBackgroundEffect">
                </div>
                <div class="_line _waveBackgroundEffect"
                     [dfs]="'m-t:2 br:50'"></div>
            </div>
        </ng-container>
    </div>
</ng-template>